// ─── Frontend mirror of backend enums (juridia-back/app/models/db.py) ────────

// Legislation Document Types
export const LEGISLATION_DOC_TYPES = {
  constitution: 'constitution',
  decision: 'decision',
  decree: 'decree',
  decree_law: 'decree-law',
  federal_law: 'federal-law',
  gazette: 'gazette',
  law: 'law',
  legislation: 'legislation',
  regulation: 'regulation',
  resolution: 'resolution',
  treaty: 'treaty',
}

export const CASE_LAW_DOC_TYPE = 'case-law'

// Jurisdiction Levels
export const JURISDICTION_LEVELS = {
  federal: 'federal',
  emirate: 'emirate',
  free_zone: 'free_zone',
}

// Jurisdiction Names
export const JURISDICTION_NAMES = {
  // Federal
  federal_uae: 'Federal UAE',
  united_arab_emirates: 'United Arab Emirates',
  // Emirates
  abu_dhabi: 'Abu Dhabi',
  dubai: 'Dubai',
  sharjah: 'Sharjah',
  ras_al_khaimah: 'Ras Al Khaimah',
  // Free Zones — Abu Dhabi
  adgm: 'ADGM',
  // Free Zones — Dubai
  dieza: 'DIEZA',
  difc: 'DIFC',
  dmcc: 'DMCC',
  jafza: 'JAFZA',
  mfz: 'MFZ',
}

// Parent emirate mapping for free zones
export const FREE_ZONE_PARENT_EMIRATE = {
  ADGM: 'Abu Dhabi',
  DIEZA: 'Dubai',
  DIFC: 'Dubai',
  DMCC: 'Dubai',
  JAFZA: 'Dubai',
  MFZ: 'Dubai',
}

// 3-level jurisdiction tree for sidebar rendering
export const JURISDICTION_TREE = [
  {
    level: JURISDICTION_LEVELS.federal,
    label: 'Federal',
    children: [
      { name: 'Federal UAE' },
      { name: 'United Arab Emirates' },
    ],
  },
  {
    level: JURISDICTION_LEVELS.emirate,
    label: 'Emirates',
    children: [
      { name: 'Abu Dhabi' },
      { name: 'Dubai' },
      { name: 'Sharjah' },
      { name: 'Ras Al Khaimah' },
    ],
  },
  {
    level: JURISDICTION_LEVELS.free_zone,
    label: 'Free Zones',
    children: [
      {
        parent: 'Abu Dhabi',
        zones: [{ name: 'ADGM' }],
      },
      {
        parent: 'Dubai',
        zones: [
          { name: 'DIEZA' },
          { name: 'DIFC' },
          { name: 'DMCC' },
          { name: 'JAFZA' },
          { name: 'MFZ' },
        ],
      },
    ],
  },
]

// Legal Domains — Substantive areas of law (Subject Matter), UAE framework
export const LEGAL_DOMAINS = {
  civil_law: 'Civil Law',
  criminal_law: 'Criminal Law',
  commercial_law: 'Commercial Law',
  labor_law: 'Labor & Employment Law',
  administrative_law: 'Administrative Law',
  constitutional_law: 'Constitutional Law',
  family_law: 'Family & Personal Status Law',
  real_estate_law: 'Real Estate & Property Law',
  banking_finance_law: 'Banking & Finance Law',
  intellectual_property: 'Intellectual Property Law',
  insurance_law: 'Insurance Law',
  maritime_law: 'Maritime Law',
  international_law: 'International Law & Treaties',
  health_law: 'Health & Medical Law',
  education_law: 'Education Law',
  environmental_law: 'Environmental Law',
  tax_customs_law: 'Tax & Customs Law',
  technology_law: 'Technology & Cybersecurity Law',
  immigration_law: 'Immigration & Nationality Law',
  energy_law: 'Energy & Natural Resources Law',
}

// Case Type Categories
export const CASE_TYPE_CATEGORIES = {
  civil: 'civil',
  commercial: 'commercial',
  criminal: 'criminal',
  administrative: 'administrative',
  labor: 'labor',
  family: 'family',
  personal_status: 'personal_status',
  constitutional: 'constitutional',
  real_estate: 'real_estate',
  banking: 'banking',
  insurance: 'insurance',
  maritime: 'maritime',
  unknown: 'unknown',
}

// Doc type colors (UAE)
export const DOC_TYPE_COLORS = {
  constitution: '#8e24aa',
  decision: '#f57c00',
  decree: '#388e3c',
  'decree-law': '#0288d1',
  'federal-law': '#1565c0',
  gazette: '#78909c',
  law: '#1976d2',
  legislation: '#5c6bc0',
  regulation: '#00897b',
  resolution: '#ef6c00',
  treaty: '#0288d1',
  'case-law': '#ff5722',
}

/**
 * Returns the doc_types available for search/retrieval in a given country.
 * Matches the backend COUNTRY_COLLECTION_MAP — regulation is only available
 * for countries that have regulation collections indexed (currently MA only).
 *
 * @param {string} country - Country code (e.g., "MA", "AE")
 * @returns {string} Comma-separated doc_types string (e.g., "law,case-law,regulation")
 */
export const getDocTypesForCountry = (country) => {
  const base = ['law', 'case-law'];
  // Regulation collections are currently available for Morocco only.
  // Add other country codes here as their regulation indices are built.
  const countriesWithRegulation = ['MA'];
  if (countriesWithRegulation.includes(country)) {
    base.push('regulation');
  }
  return base.join(',');
};

// Returns filter configuration for a country
// Only UAE has filters; other countries return empty config
export const getFiltersForCountry = (country) => {
  if (country === 'AE') {
    return {
      hasFilters: true,
      jurisdictionTree: JURISDICTION_TREE,
      legalDomains: LEGAL_DOMAINS,
      caseTypeCategories: CASE_TYPE_CATEGORIES,
      docTypes: LEGISLATION_DOC_TYPES,
    }
  }
  return { hasFilters: false }
}
